import Vue from 'vue';
import Vuex from 'vuex';
import main from './modules/main';
import portfolioProjectDetails from './modules/portfolioProjectDetails';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        main,
        portfolioProjectDetails
    },
    strict: debug
})